export default __webpack_public_path__ + "static/media/blackcar.8b305149.jpg";